<script setup lang="ts">
import { queryDealerShopServiceProductById } from '@user-center/api/common'
import { reactive, ref } from 'vue'
import BaseRateTable from './BaseRateTable/index.vue'
import { getCurrencyNum,getCurrencySymbol } from "@user-center/utils/qiankun.ts";
import { storeData } from '@user-center/utils/localService'
 

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  isExpanded: {
    type: Boolean,
    default: false,
  },
  transfersMap: {
    type: Object,
    default: () => ({}),
  },
})
const emit = defineEmits(['toggleDetails'])

const state = reactive({
  infoData: {} as any,
})

const loading = ref(false)
function getStoreInformation() {
  if (!process.client) {
    return null
  }

  const raw = window.localStorage.getItem(storeData.StoreInformation)
  if (!raw) {
    return null
  }

  try {
    return JSON.parse(raw)
  }
  catch {
    return null
  }
}

async function getDetail() {
  emit('toggleDetails')
  loading.value = true
  try {
    const storeInformation = getStoreInformation()
    if (!storeInformation?.id || !props.item?.id) {
      return
    }

    const res: any = await queryDealerShopServiceProductById({
      shopId: storeInformation.id,
      productId: props.item.id,
    })

    const data = res.data
    let productCalValue = null
    if (data.productCal.value) {
      try {
        productCalValue = JSON.parse(data.productCal.value)
      }
      catch (error) {
        console.log('format productCal value error', error)
      }
    }

    state.infoData = {
      ...data,
      productCalValue,
    }
  }
  finally {
    loading.value = false
  }
}
</script>

<template>
  <div class="p-6" style="border-bottom: 1px solid var(--el-border-color);">
    <div class="flex gap-36px">
      <div class="text-center" style="flex: 0 0 200px;">
        <!-- <el-avatar size="large" /> -->
        <div class="text-16px font-700 lh-30px mt-2">
          {{ transfersMap[item.productName]?transfersMap[item.productName]:item.productName }}
        </div>
      </div>
      <div class="flex text-center" style="flex: 0 0 320px;">
        <div style="flex: 0 0 200px;">
          <p>{{ $t('text.shippingFee') }}</p>
          <p class="text-red text-18px font-700 lh-30px">
            ￥{{ item.price }}

            <template v-if="getCurrencySymbol('¥') != '¥'">
              <br />
              ≈  {{ getCurrencySymbol('¥') }} {{ getCurrencyNum(item.price) }}
              
            </template>
          </p>
        </div>
        <div style="flex: 0 0 120px;">
          <p>{{ $t('text.transitTime') }}</p>
          <p class="text-18px font-700 lh-30px">
            {{ item.timeScope || '~' }}
            <span class="text-12px align-top">days</span>
          </p>
        </div>
      </div>
      <div class="flex-1 pl-10">
        <div>
          <p>{{ $t('text.shippingMode') }}</p>
          <p class="text-14px font-700 lh-30px">
            {{  transfersMap[item.freightType]?transfersMap[item.freightType]:item.freightType }}
          </p>
        </div>
        <div>
          <p />
          {{ $t('estimation.carrierOptional') }}
          <p class="text-14px font-700 lh-30px">
            {{ item.carrierList.map(o=>{
              return transfersMap[o]?transfersMap[o]:o
            }).join(',') }}
          </p>
        </div>
      </div>
      <div class="select-btn-wrapper text-center" style="flex: 0 0 200px;">
        <el-button
          class="base-ui-primary"
          :plain="isExpanded"
          @click="getDetail"
        >
          {{ isExpanded ? $t('actions.collapse') : $t('actions.viewDetails') }}
        </el-button>
      </div>
    </div>
    <div v-show="isExpanded">
      <el-divider />
      <div
        v-if="loading"
        v-loading="loading"
        class="w-full min-h-200px"
      />
      <template v-else>
        <div v-if="state.infoData.productCalValue">
          <div class="text-16px lh-30px my-3 font-700">
            {{ $t('estimation.feeStandard') }}
          </div>
          <BaseRateTable
            v-model="state.infoData.productCalValue"
            disabled
          />
        </div>
        <div class="mt-8">
          <div class="text-16px lh-30px my-3 font-700">
            {{ $t('estimation.routeIntroduction') }}
          </div>
          <div v-html="state.infoData.transfersMap&&state.infoData.transfersMap[state.infoData.productDesc || '-']?state.infoData.transfersMap[state.infoData.productDesc || '-']:(state.infoData.productDesc || '-')" />
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.select-btn-wrapper {
  :deep(.el-button) {
    border-radius: 20px;
    height: 40px;
    min-width: 110px;
  }
}
</style>
